import { useConfig } from '../Providers/ConfigProvider'
import { CheckUnfinishedTaskForSendPriceList } from '../Services/CustomerService'

const useCommercialOfferWithSample = () => {
    const { api } = useConfig()

    const handleGetCommercialOfferStarterData = async (siteId, whId, custId) => {
        try {
            let res = await api.get(`/api/v1/Offer/getCommercialOfferStarterData`, {
                params: { siteId, whId, custId }
            })
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    const hendleGetCommercialOfferAssortsForDiscountGroup = async (siteId, whId, custId, discountGroups) => {
        try {
            let res = await api.post(`/api/v1/Offer/getCommercialOfferAssortsForDiscountGroup`, discountGroups, {
                params: { siteId, whId, custId }
            })
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    const handleRecalculateCustomerDiscount = async (group, marginMode = true) => {
        try {
            let res = await api.post(`/api/v1/Offer/recalculateCustomerDiscount`, group, {
                params: { marginMode }
            })
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    const handleRecalculateCustomerDiscountForArtNo = async (assort, marginMode = true) => {
        try {
            let res = await api.post(`/api/v1/Offer/recalculateCustomerDiscountForArtNo`, assort, {
                params: { marginMode }
            })
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    const handleCheckUnfinishedTaskForSendPriceList = async (custId) => {
        try {
            let res = await CheckUnfinishedTaskForSendPriceList(api, custId)
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    const handleSaveCustomerHanDiscounts = async (custId, offerEffectiveDate, discountsToSave) => {
        try {
            let res = await api.post(`/api/v1/Offer/saveCustomerHanDiscounts`, discountsToSave, {
                params: { custId, offerEffectiveDate }
            })
            return res.data
        } catch (error) {
            console.log(error)
            return null
        }
    }

    return {
        handleGetCommercialOfferStarterData,
        hendleGetCommercialOfferAssortsForDiscountGroup,
        handleRecalculateCustomerDiscount,
        handleRecalculateCustomerDiscountForArtNo,
        handleSaveCustomerHanDiscounts,
        handleCheckUnfinishedTaskForSendPriceList,
    }

}

export default useCommercialOfferWithSample